import React, { Component } from "react";
import '../App.css';
import lozad from 'lozad';

export default function Project13 () {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
    return (
      <div className="pt-3">
        <p>Monochrome christmas</p>
        <p>Over the festive period I took some inspiration  </p>

          <div className="text-center">
          <img className="pb-3 lozad" width="100%" src="../images/12/test1.png" alt="Confident" />
        </div>
      </div>
    );  
  }
